/**
 * Change Log Button Component
 * 
 * A reusable button to open the Change Log Drawer
 * Used across exhibits (EX2-EX9)
 */

import React, { useState } from 'react';
import { Button } from 'antd';
import { HistoryOutlined } from '@ant-design/icons';
import AdminChangeLogDrawer from './AdminChangeLogDrawer';


export interface ChangeLogButtonProps {
  title?: string;
}

const ChangeLogButton: React.FC<ChangeLogButtonProps> = ({
  title = 'View change history',
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <Button
        type="primary"
        icon={<HistoryOutlined />}
        onClick={() => setDrawerOpen(true)}
        title={title}
        style={{ width: 40, height: 40 }}
      />
      <AdminChangeLogDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      />
    </>
  );
};

export default ChangeLogButton;
